import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SubmitButton } from "../../components/Input";

const WebsiteReviewsForm = () => {
  const [description, setDescription] = useState("");
  const [reviewBy, setReviewBy] = useState("");
  const [productApp, setProductApp] = useState("0"); // Default to Streetgains
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch data for edit mode
  const fetchReview = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}testimonials/form?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = response.data.data;
      setDescription(data.description || "");
      setReviewBy(data.reviewby || "");
      setProductApp(data.product_app?.toString() || "0"); // Set product_app from API
    } catch (error) {
      console.error("Fetch Error:", error);
      showToast.error("Failed to load review data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchReview();
    }
  }, [id]);

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!description || !reviewBy) {
      showToast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const url = id
        ? `${API_URL}testimonials/save?id=${id}`
        : `${API_URL}testimonials/save`;

      const payload = {
        description,
        reviewby: reviewBy,
        product_app: parseInt(productApp), // 0 for Streetgains, 1 for Streetfolio
        isActive: true,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(url, payload, config);

      if (response.data.success) {
        showToast.success(response.data.message || "Review saved successfully");
        navigate("/WebsiteReviews");
      } else {
        showToast.error(response.data.message || "Failed to save review");
      }
    } catch (error) {
      console.error("Submit Error:", error);
      showToast.error(error.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div className="panel-heading border-0">
        <span className="panel-title">
          {id ? "Edit" : "Add"} Website Review
        </span>
      </div>

      <div className="panel-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="control-label">Review By</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter reviewer name"
                value={reviewBy}
                onChange={(e) => setReviewBy(e.target.value)}
                required
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <label className="control-label">Product Type</label>
              <select
                className="form-control"
                value={productApp}
                onChange={(e) => setProductApp(e.target.value)}
                required
              >
                <option value="0">Streetgains</option>
                <option value="1">Streetfolio</option>
              </select>
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-12 mb-3">
              <label className="control-label">Description</label>
              <textarea
                className="form-control"
                rows={2}
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              ></textarea>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <SubmitButton
                pageBack={"/WebsiteReviews"}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WebsiteReviewsForm;